import {css} from 'lit';
export const styles = css`:host {
  --value-border-radius: 0;
  --value-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);

  display: block;
  width: 100%;
  height: 8px;
  background-color: #f3f3f3;
  background-color: var(--gray-100, #f3f3f3);
  border-radius: 4px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

div {
  height: 100%;
  background-color: var(--info);
  box-shadow: var(--value-box-shadow);
  transition: width 0.6s ease;
  border-top-right-radius: var(--value-border-radius);
  border-bottom-right-radius: var(--value-border-radius);
}
`;
export default styles;
